"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts_1 = require("../consts");
var mapUser = function (user) {
    var mappedUser = {
        profileCompletion: (user === null || user === void 0 ? void 0 : user.profileCompletion) || consts_1.NOT_AVAILABLE,
        membershipTier: (user === null || user === void 0 ? void 0 : user.membershipTier) || consts_1.NOT_AVAILABLE,
        membershipStatus: (user === null || user === void 0 ? void 0 : user.membershipStatus) || consts_1.NOT_AVAILABLE,
        region: (user === null || user === void 0 ? void 0 : user.region) || consts_1.NOT_AVAILABLE,
        autoRenewal: (user === null || user === void 0 ? void 0 : user.autoRenewal) || consts_1.NOT_AVAILABLE,
        certificationStatus: (user === null || user === void 0 ? void 0 : user.certificationStatus) || consts_1.NOT_AVAILABLE,
        pduStatus: (user === null || user === void 0 ? void 0 : user.pduStatus) || consts_1.NOT_AVAILABLE,
        pmiID: (user === null || user === void 0 ? void 0 : user.pmiID) || consts_1.NOT_AVAILABLE,
        pmID: (user === null || user === void 0 ? void 0 : user.pmID) || consts_1.NOT_AVAILABLE,
        membershipSegment: (user === null || user === void 0 ? void 0 : user.membershipSegment) || consts_1.NOT_AVAILABLE,
        certificationSegment: (user === null || user === void 0 ? void 0 : user.certificationSegment) || consts_1.NOT_AVAILABLE,
        userSegment: (user === null || user === void 0 ? void 0 : user.userSegment) || consts_1.NOT_AVAILABLE,
        accountid: (user === null || user === void 0 ? void 0 : user.accountid) || consts_1.NOT_AVAILABLE,
        accountName: (user === null || user === void 0 ? void 0 : user.accountName) || consts_1.NOT_AVAILABLE,
        dealid: (user === null || user === void 0 ? void 0 : user.dealid) || consts_1.NOT_AVAILABLE,
        lineofbusiness: (user === null || user === void 0 ? void 0 : user.lineofbusiness) || consts_1.NOT_AVAILABLE,
    };
    return mappedUser;
};
exports.default = mapUser;
